import Particle, { Ray } from './Particle';

const numberOfParticles = 18;
const numberOfRays = 60;

export default class ParticleGenerator {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  particles: Particle[] = [];
  rays: Ray[] = [];
  rayGradient: CanvasGradient;
  ctr: { x: number; y: number };

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');

    this.ctr = {
      x: this.canvas.width / 2,
      y: this.canvas.height / 2,
    };

    this.rayGradient = this.ctx.createLinearGradient(0, -1, this.canvas.width / 2, 1);
    this.rayGradient.addColorStop(0.3, 'rgba(255, 255, 255, 0.5)');
    this.rayGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
  }

  removeParticleAt = (i: number) => {
    this.particles.splice(i, 1);
  };

  removeRayAt = (i: number) => {
    this.rays.splice(i, 1);
  };

  addParticle = () => {
    return new Particle(this.ctx, this.ctr);
  };

  addRay = () => {
    return new Ray(this.ctx, this.ctr, this.rayGradient);
  };

  addParticlesUntil = (particleCount: number) => {
    for (let i = this.particles.length; i < particleCount; i++) {
      this.particles.push(this.addParticle());
    }
  };

  addRaysUntil = (rayCount: number) => {
    for (let i = this.rays.length; i < rayCount; i++) {
      this.rays.push(this.addRay());
    }
  };

  animate = () => {
    if (this.particles.length < numberOfParticles) {
      this.addParticlesUntil(numberOfParticles);
    }

    if (this.rays.length < numberOfRays) {
      this.addRaysUntil(numberOfRays);
    }

    this.particles.forEach((p, i) => {
      p.update();

      if (p.isOffCanvas()) {
        if (this.particles.length <= numberOfParticles) {
          this.particles[i] = this.addParticle();
        } else {
          this.removeParticleAt(i);
        }
      }
    });

    this.rays.forEach((r, i) => {
      r.update();

      if (r.isOffCanvas()) {
        if (this.rays.length <= numberOfRays) {
          this.rays[i] = this.addRay();
        } else {
          this.removeRayAt(i);
        }
      }
    });
  };
}
